"use client";
import { jsx } from "react/jsx-runtime";
import { ZIPCODE_QUERY_PARAM } from "../../../../utils/constants.js";
import { Link, Text } from "@nxt-costco-com/forge-components";
import { Analytics } from "../../../Analytics/index.js";
import "../../../Chrome/BrowseContext/ContextProvider.js";
import { useBrowseContext } from "../../../Chrome/BrowseContext/hook.js";
import { CostcoBox } from "../../../Util/CostcoBox.js";
const SameDay = ({
  entry
}) => {
  const { deliveryLocation } = useBrowseContext();
  if (!entry) return null;
  let url = entry.active_state.active_state_link.href;
  url = deliveryLocation.zipCode && url ? url.replace(
    ZIPCODE_QUERY_PARAM,
    ZIPCODE_QUERY_PARAM + deliveryLocation.zipCode
  ) : url;
  return /* @__PURE__ */ jsx(
    Analytics,
    {
      analyticData: {
        component: {
          trackedData: [
            entry.active_state.active_state_link.title
          ]
        }
      },
      children: /* @__PURE__ */ jsx(
        Link,
        {
          href: url,
          target: entry.target,
          uniqueId: entry.active_state.active_state_link.title,
          children: /* @__PURE__ */ jsx(CostcoBox, { children: /* @__PURE__ */ jsx(
            Text,
            {
              uniqueId: entry.active_state.active_state_link.title,
              children: entry.active_state.active_state_link.title
            }
          ) })
        }
      )
    }
  );
};
export {
  SameDay
};
